"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarField = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../atoms/Label/index.js");

var _index2 = require("../Flex/index.js");

var _styles = require("./styles.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CalendarIcon = function CalendarIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
  }));
};

CalendarIcon.defaultProps = {
  "'data-prefix'": "far",
  "'data-icon'": "calendar",
  className: "svg-inline--fa fa-calendar fa-w-14",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};

var CalendarField = function CalendarField(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? new Date() : _ref$value,
      onChange = _ref.onChange,
      id = _ref.id,
      label = _ref.label,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/_react["default"].createElement(_index2.Flex, {
    flex: "1",
    flexDirection: "column"
  }, label && /*#__PURE__*/_react["default"].createElement(_index.Label, {
    htmlFor: id,
    required: required,
    disabled: disabled
  }, label), /*#__PURE__*/_react["default"].createElement(_styles.DatePickerWrapper, {
    selected: value
  }, /*#__PURE__*/_react["default"].createElement(_styles.InputIcon, null, /*#__PURE__*/_react["default"].createElement(CalendarIcon, null)), /*#__PURE__*/_react["default"].createElement(_styles.StyledDatePicker, {
    selected: value,
    onChange: onChange
  })));
};

exports.CalendarField = CalendarField;